import CloseIcon from "@mui/icons-material/Close";
import UpdateIcon from "@mui/icons-material/Update";
import {
  IconButton,
  LinearProgress,
  Modal,
  Paper,
  Tooltip,
  Typography
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { QueryNewWebServicePreview_solutions_Solutions_solution_Solution_useCases_UseCasesViewModel_calculationRule_CalculationRuleViewModel_schema_UseCaseSchema as QueryNewWebServicePreview_solutions_solution_useCases_calculationRule_schema } from "../create/hooks/schema/QueryNewWebServicePreview";
import {
  QueryUpgradeWebservicePreview_solutions_Solutions_solution_Solution_useCases_UseCasesViewModel_useCase_UseCaseViewModel_detail_UseCaseDetail_nextVersion_NextVersion_schema_UseCaseSchema as QueryUpgradeWebservicePreview_solutions_solution_useCases_useCase_detail_nextVersion_schema,
  QueryUpgradeWebservicePreview_solutions_Solutions_solution_Solution_useCases_UseCasesViewModel_useCase_UseCaseViewModel_detail_UseCaseDetail_nextVersion_NextVersion_schemaDiff_SchemaDiffs as QueryUpgradeWebservicePreview_solutions_solution_useCases_useCase_detail_nextVersion_schemaDiff
} from "../create/hooks/schema/QueryUpgradeWebservicePreview";
import TechnicalChangelog from "./TechnicalChangelog";
import {
  SchemaDiff_solutions_Solutions_solution_Solution_useCases_UseCasesViewModel_useCase_UseCaseViewModel_detail_UseCaseDetail_schemaDiff_SchemaDiffs as SchemaDiff_solutions_solution_useCases_useCase_detail_schemaDiff,
  SchemaDiff_solutions_Solutions_solution_Solution_useCases_UseCasesViewModel_useCase_UseCaseViewModel_schema_UseCaseSchema as SchemaDiff_solutions_solution_useCases_useCase_schema
} from "./components/schema/SchemaDiff";

const useStyles = makeStyles(theme => ({
  paper: {
    position: "absolute",
    top: "10vh",
    left: "10vw",
    width: "80vw",
    height: "80vh",
    overflow: "hidden",
    padding: theme.spacing(2),
    display: "flex"
  },
  content: {
    paddingTop: theme.spacing(2),
    height: "calc(100% - 30px)"
  },
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%"
  },
  flex: { display: "flex", justifyContent: "space-between" }
}));

const TechnicalChangelogButton = ({
  schema,
  schemaDiff,
  loading,
  isChangelogOpened,
  toggleChangelog
}: {
  schema?:
    | SchemaDiff_solutions_solution_useCases_useCase_schema
    | QueryNewWebServicePreview_solutions_solution_useCases_calculationRule_schema
    | QueryUpgradeWebservicePreview_solutions_solution_useCases_useCase_detail_nextVersion_schema
    | null;
  schemaDiff?:
    | SchemaDiff_solutions_solution_useCases_useCase_detail_schemaDiff
    | QueryUpgradeWebservicePreview_solutions_solution_useCases_useCase_detail_nextVersion_schemaDiff
    | undefined
    | null;
  loading?: boolean;
  isChangelogOpened: boolean;
  toggleChangelog: () => void;
}) => {
  const classNames = useStyles();

  return (
    <>
      <Tooltip title={<Typography>Current version changelog</Typography>}>
        <IconButton size="small" onClick={toggleChangelog}>
          <UpdateIcon />
        </IconButton>
      </Tooltip>
      <Modal open={isChangelogOpened} onClose={toggleChangelog}>
        <Paper className={classNames.paper}>
          {loading && <LinearProgress />}
          {schema && (
            <div className={classNames.root}>
              <div className={classNames.flex}>
                <Typography> Changelog </Typography>
                <IconButton
                  size="small"
                  onClick={toggleChangelog}
                  data-testid="changelog-close"
                >
                  <CloseIcon />
                </IconButton>
              </div>
              <div className={classNames.content}>
                <TechnicalChangelog schemaDiff={schemaDiff} schema={schema} />
              </div>
            </div>
          )}
        </Paper>
      </Modal>
    </>
  );
};

export default TechnicalChangelogButton;
